import React, { Suspense, lazy } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";

// Lazy load all screen components
const HomeScreen = lazy(() => import("./screen/home/HomeScreen"));
const AboutScreen = lazy(() => import("./screen/about/AboutScreen"));
const ContactScreen = lazy(() => import("./screen/contact/ContactScreen"));
const CookiePolicy = lazy(() => import("./screen/CookiePolicy"));
const PrivacyPolicy = lazy(() => import("./screen/PrivacyPolicy"));
const StaffAugmentationScreen = lazy(() =>
  import("./screen/services/staffAugmentation/StaffAugmentationScreen")
);
const ITConsultingScreen = lazy(() =>
  import("./screen/services/ITConsulting/ITConsultingScreen")
);
const DraftReport = lazy(() => import("./screen/DraftReport"));
const DraftReport1 = lazy(() => import("./screen/DraftReport1"));

export default function CustomRoutes() {
  return (
    <Suspense
      fallback={
        <div className="preloader" id="preloader">
          <div className="spinner"></div>
        </div>
      }
    >
      <Routes>
        <Route path="/" exact element={<HomeScreen />} />
        <Route path="/About" element={<AboutScreen />} />
        <Route path="/Contact" element={<ContactScreen />} />
        <Route path="/CookiePolicy" element={<CookiePolicy />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route
          path="/StaffAugmentation"
          element={<StaffAugmentationScreen />}
        />
        <Route path="/ITConsulting" element={<ITConsultingScreen />} />
        <Route path="/Report1" element={<DraftReport />} />
        <Route path="/Report2" element={<DraftReport1 />} />
      </Routes>
    </Suspense>
  );
}
